import { render, staticRenderFns } from "./UnavailabilityIntervalsListPage.vue?vue&type=template&id=d481473a&"
import script from "./UnavailabilityIntervalsListPage.vue?vue&type=script&lang=ts&"
export * from "./UnavailabilityIntervalsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports